const TwgMap = require('../common/twg_map');
const markerClusterer = require('@googlemaps/markerclusterer');
const _ = require('underscore');

var ProjectMap = (function () {
  let PIN_COLORS = undefined;
  let SVG_PATH = undefined;
  ProjectMap = class ProjectMap extends TwgMap {
    static initClass() {
      PIN_COLORS = {
        red: '#db3236',
        yellow: '#f4c20d',
        green: '#3cba54',
        gray: '#999',
        blue: '#4885ed',
        purple: '#bf48ed',
      };

      SVG_PATH =
        'M 0,0 C -2,-20 -10,-22 -10,-30 A 10,10 0 1,1 10,-30 C 10,-22 2,-20 0,0 z M -2,-30 a 2,2 0 1,1 4,0 2,2 0 1,1 -4,0';
    }

    constructor(
      $map,
      boundsChangedCallback,
      legendValues,
      assetClickCallback = null,
      kmzFiles,
      external,
      defaultZoom,
    ) {
      if (kmzFiles == null) {
        kmzFiles = [];
      }
      if (defaultZoom == null) {
        defaultZoom = 16;
      }
      super($map, kmzFiles);

      this.markers = {};
      this.infoWindow = new google.maps.InfoWindow({ content: '' });
      this.focusZoom = 18; // When centering a map on a marker, force zoom to this level
      this.defaultZoom = defaultZoom; // When initializing the map, start at this zoom level
      this.assetClickCallback = assetClickCallback;
      this.boundsChangedCallback = boundsChangedCallback;
      this.legendValues = legendValues;
      this.external = external;
      this.pinColors = PIN_COLORS;
      this.svgPath = SVG_PATH;

      if (this.assetClickCallback) {
        google.maps.event.addListener(
          this.infoWindow,
          'closeclick',
          function () {
            return this.assetClickCallback(null);
          },
        );
      }

      this.$togglePins = $(
        "<div class='pin-control show-pins'>Hide Pins</div>",
      );

      this.createLegend();
      this.setMapIdleCallback(_.bind(this.boundsChanged, this));
      this.setMarkerClusterer();
      this.init();
    }

    init() {
      this.setCenterControl();
      this.setTogglePins();
      return this.createFollowControl();
    }

    setMarkerClusterer() {
      return (this.markerClusterer = new markerClusterer.MarkerClusterer({
        map: this.map,
        markers: [],
      }));
    }

    setMapPosition(latitude, longitude) {
      if (this.map) {
        return this.map.setCenter({ lat: latitude, lng: longitude });
      }
    }

    setMarkersFromAssets(assets) {
      const asset_markers = [];
      for (let index = 0; index < assets.length; index++) {
        var asset = assets[index];
        asset_markers.push(this.createMarkerFromAsset(asset));
      }

      return this.markerClusterer.addMarkers(asset_markers);
    }

    createMarkerFromAsset(asset) {
      const pinSettings = {
        asset,
        icon: this.pinSymbol(asset.marker_color),
        position: {
          lat: asset.latitude,
          lng: asset.longitude,
        },
        map: this.map,
      };
      if (asset.marker_label) {
        pinSettings['label'] = {
          text: asset.marker_label,
          fontWeight: 'bold',
          fontSize: '32px',
          color: 'black',
        };
      }

      const marker = new google.maps.Marker(pinSettings);
      this.markers[`asset_${asset.id}`] = marker;
      if (this.assetClickCallback) {
        this.setMarkerInfoBox(marker, asset);
      }
      return marker;
    }

    pinSymbol(marker_color) {
      return {
        path: this.svgPath,
        fillColor: this.pinColorForAsset(marker_color),
        fillOpacity: 1,
        strokeColor: '#000',
        strokeWeight: 1,
        scale: 1,
        labelOrigin: new google.maps.Point(0, -27),
      };
    }

    pinColorForAsset(marker_color) {
      return this.pinColors[marker_color];
    }

    setMarkersForUsers(user_locations) {
      return user_locations.map((user_location) =>
        this.createMarkerForUser(user_location),
      );
    }

    createMarkerForUser(user) {
      const marker = new google.maps.Marker({
        user,
        label: { text: user.initials },
        icon: {
          path: google.maps.SymbolPath.CIRCLE,
          scale: 15,
          fillColor: '#7FB3D5',
          strokeColor: '#7FB3D5',
          fillOpacity: 0.3,
          strokeWeight: 5,
        },
        position: {
          lat: user.lat,
          lng: user.long,
        },
        map: this.map,
      });

      return (this.markers[`user_${user.user_id}`] = marker);
    }

    setMapIdleCallback(callback) {
      const self = this.map;
      return this.map.addListener('idle', function () {
        const bounds = self.getBounds();
        return callback(bounds);
      });
    }

    getAssetCount() {
      let asset_count = 0;
      for (var id in this.markers) {
        if (this.isAsset(id)) {
          asset_count = asset_count + 1;
        }
      }
      return asset_count;
    }

    clearAllMarkers() {
      for (var id in this.markers) {
        if (id.includes('asset_')) {
          var marker = this.markers[id];
          marker.setMap(null);
        }
      }
      this.markers = {};
      return this.markerClusterer.clearMarkers();
    }

    boundsChanged(newBounds) {
      const threshhold = 0.001;

      if (!this.showPins()) {
        return;
      }

      const oldBounds = this.lastBounds;

      if (oldBounds) {
        const oldNE = oldBounds.getNorthEast();
        const newNE = newBounds.getNorthEast();

        if (
          Math.abs(oldNE.lat() - newNE.lat()) < threshhold &&
          Math.abs(oldNE.lng() - newNE.lng()) < threshhold
        ) {
          // If the map has only moved a little, don't worry about it for now
          return;
        }
      }

      if (newBounds) {
        this.lastBounds = newBounds;
        return this.boundsChangedCallback(newBounds);
      }
    }

    //-----------  Private  -----------#

    findAssetMarker(assetId) {
      return this.markers[`asset_${assetId}`];
    }

    isAsset(markerId) {
      return markerId.includes('asset');
    }

    centerMapOnPosition(pos) {
      this.map.setZoom(this.focusZoom);
      return this.map.setCenter(pos);
    }

    showMarkerInfoBox(marker, asset) {
      this.infoWindow.setContent(this.constructInfoBubble(asset));
      return this.infoWindow.open(this.map, marker);
    }

    setMarkerInfoBox(marker, asset) {
      return marker.addListener('click', () => {
        this.showMarkerInfoBox(marker, asset);
        return this.callAssetClickCallback(asset);
      });
    }

    callAssetClickCallback(asset) {
      if (this.assetClickCallback) {
        return this.assetClickCallback(asset);
      }
    }

    constructInfoBubble(asset) {
      let info_bubble_html = this.external
        ? ''
        : `<a href=${asset.edit_path} class='asset-link'>`;

      for (var method_name in asset.info_bubble) {
        var data = asset.info_bubble[method_name];
        info_bubble_html += `<div><strong>${method_name}:</strong> ${
          data || ''
        } </div>`;
      }

      return info_bubble_html;
    }

    createLegend() {
      const legend = $('#pin-legend');
      return (() => {
        const result = [];
        for (var i in this.legendValues) {
          var value = this.legendValues[i];
          var hex = this.pinColors[value['color']];
          var statusLabel = value['label'];
          var container = $("<span class='icon-container'></span>");
          var svg = $(
            `<svg width='30' height='30' viewBox='-15 -45 30 45'><path fill=${hex} stroke='black' stroke-width='1' d=\"${this.svgPath}\"/></svg>`,
          );
          var label = $(`<span>${statusLabel}</span>`);
          svg.appendTo(container);
          label.appendTo(container);
          result.push(legend.append(container));
        }
        return result;
      })();
    }

    createFollowControl() {
      const $controlUI = $("<div class='map-control right'></div>");
      const $controlText = $('<div>Follow</div>');
      $controlUI.append($controlText);
      $controlUI.click((event) => {
        const button = $(event.target);
        button.toggleClass('toggled');
        const toggled = button.hasClass('toggled');

        this.setMapLock(toggled);
        this.startGeolocationListener(toggled);
        return button.text(toggled ? 'Stop Following' : 'Follow');
      });

      return this.map.controls[google.maps.ControlPosition.TOP_RIGHT].push(
        $controlUI[0],
      );
    }

    setCenterControl() {
      const $controlUI = $("<div class='map-control'></div>");
      const $controlText = $('<div>Center Map</div>');
      $controlUI.append($controlText);
      $controlUI.click(() => {
        return this.map.setCenter(this.centerLocation);
      });
      return this.map.controls[google.maps.ControlPosition.TOP_CENTER].push(
        $controlUI[0],
      );
    }

    setTogglePins() {
      const self = this;
      this.$togglePins.click(() => {
        if (self.showPins()) {
          self.clearAllMarkers();
        } else {
          self.boundsChangedCallback(this.map.getBounds());
        }

        return self.togglePinsClass();
      });

      return this.map.controls[google.maps.ControlPosition.BOTTOM_LEFT].push(
        this.$togglePins[0],
      );
    }

    showPins() {
      return this.$togglePins.hasClass('show-pins');
    }

    togglePinsClass() {
      this.$togglePins.toggleClass('show-pins');
      return this.$togglePins.text(this.showPins() ? 'Hide Pins' : 'Show Pins');
    }
  };
  ProjectMap.initClass();
  return ProjectMap;
})();

//-----------  Export  -----------#
module.exports = ProjectMap;
